/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React, { Component, createRef, forwardRef } from 'react';
import { Dropdown, Form, Spinner } from 'react-bootstrap'
import { connect } from 'react-redux';
import {
    LivingRoom,
    KitchenDinning,
    Barn,
    Bedroom,
    Entertainment_cave,
    Garage,
    KidsPlayroom,
    LaundryStorage,
    Office,
    PatioLawn,
    saleBannerBrown,
    saleBannerPink,
    saleBannerBlue,
    saleBannerteel,
    image_thumbnail,
    saleBannernavy,
    saleBannersky,
} from 'shared/images/images';
import store from 'features/store';
import { EstateSaleMenuList } from './EstateSaleMenuList';
import { SalesService, LocationService, CategoryService } from 'shared/services';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';

import { convertToMaintainData, estateSaleCategory, getMaintainData, previousState } from 'shared/settings/stateMaintain';
import { gaID } from 'shared/settings/gaConfig';

import './EstateSaleByCategory.scss';
import { titleCase } from 'shared/modifiers';
import { notAllow } from 'shared/sale-card-view-datatable';
import { isAuthorized } from 'shared/settings/auth';
import { addDataLayer } from 'shared/utils/utils';
import { Helmet } from 'react-helmet';
/**


@Author Karthik

@param

@return Estate sale category html

**/

const CustomToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        className="form-control custom-drop-down"
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={`${process.env.PUBLIC_URL}/static/images/Common/br_down.webp`} alt="drop-down"></img>
        {/* &#x25bc; */}
    </div>
));


class EstateSaleByCategory extends Component {
    constructor(props) {
        super(props);

        this.sideNavbar = null;
        this.headerContentRef = createRef();
        this.scrollRef = this.props.scrollRef || createRef();
        this.sideNavbarRef = createRef();

        /* Banner background and home images */
        this.banner_images = [
            saleBannerBrown,
            saleBannerPink,
            saleBannerBlue,
            saleBannerteel,
            saleBannernavy,
            saleBannersky
        ]

        this.state = {
            /* Sidemenu links */
            menuList: EstateSaleMenuList(),

            /* To handle responsive */
            innerWidth: window.innerWidth,
            banner_images: this.banner_images[Math.floor(Math.random() * this.banner_images.length)],

            /* For get items based on sale */
            items: {
                "sort": [{ "field": "itemclosetime", "direction": "asc" }],
                "filter": [{ "field": "saleid", "value": parseInt(this.props.match.params.saleId), "op": "=", "join": "AND" },
                { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" }],
                "page": { "size": 48 }
            },

            /* Show and hide caring in header and filter dropdown in filter section based on scroll */
            showCaringInHeader: 0,

            saleId: this.props.match.params.saleId,

            locationDetails: {},
            saleImageList: [],
            saleDetails: {},
            locationImageList: [],
            categoryCount: { orginal: [], menu: [] },
            areaCount: [],

            pageLoading: true,
            area: [
                { name: 'Living Room', count: "Living Room" },
                { name: 'Kitchen & Dining', count: "Kitchen & Dining" },
                { name: 'Office', count: "Office" },
                { name: 'Bedroom', count: "Bedroom" },
                { name: 'Kids Playroom', count: "Kids Playroom" },
                { name: 'Garage', count: "Garage" },
                { name: 'Entertainment Cave', count: "Entertainment Cave" },
                { name: 'Laundry Storage', count: "Laundry Storage" },
                { name: 'Patio & Lawn', count: "Patio & Lawn" },
                { name: 'Barn', count: "Barn" }
            ],
            activeAreaIndex: "-1",
            activeCategory: 'ALL',
            activeMenu: 'ALL',
            showItems: true,
            scrollToPrevious: false,
            sideBarScrollHeight: 15,
            sortActive: "1",
            sidenavTop: 0,
            noRecordFound: false,
            activeMenuStatus: false,
            activeMenuValue: '',
            activeSubMenuStatus: false,
            activeSubMenuValue: '',
            isVisible: false,
            pageClientWidth: 16,
            itemCount: 0,
            favoriteDetailsLoaded: false,
            favoriteLocations: [],
            locationInProgress: false,
            isshippable: false,
            ispickuponly: false,
            saleTitle: this.props?.history?.location?.state?.saleTitle,
            windowWidth: window.innerWidth,
        }

        this.sortByMenu = {
            "1": "Ending First",
            "2": "Item Name A-Z",
            "3": "Item Name Z-A",
            "4": "Newest - Oldest",
            "5": "Oldest - Newest",
            "6": "Price High - Low",
            "7": "Price Low - High"
        };

        this.scrolledAt = 0;
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        store.dispatch({ type: 'SHOW_ESTATE_DETAIL', payload: { show: false, extraData: null } });
        store.dispatch({ type: 'SIDEBAR_MENU_LIST', payload: { menuList: EstateSaleMenuList(), withSpan: true } });

        window.onload = () => {
            this.windowWidthGet();
        };

        window.addEventListener('resize', this.windowWidthGet);
        window.addEventListener('click', this.handleClickOutside);
        this.getPreviousValues();
    }

    componentDidUpdate(prevProps) {
        // Un used condition  
        // if (this.props.location !== prevProps.location) {
        //     this.handleScroll();
        // }
        if (JSON.stringify(prevProps.user) !== JSON.stringify(this.props.user)) {
            this.windowWidthGet();
            this.handleScroll();
            this.getFavoriteLocationDetails();
        }

        if (JSON.stringify(prevProps.updateLocation) !== JSON.stringify(this.props.updateLocation)) {
            if (this.props.updateLocation && isAuthorized()) {
                this.getFavoriteLocationDetails();
                setTimeout(() => {
                    store.dispatch({ type: 'UPDATE_FAVORITE_LOCATION', payload: null });
                }, 100);
            }
        }
        window.addEventListener('resize', this.windowWidthGet);
    }
    handleResize = () => {
        if (this.state.windowWidth !== window.innerWidth) {
            store.dispatch({ type: 'SHOW_ESTATE_DETAIL', payload: { show: false, extraData: null } });
        }
      };

    /* Handle initial page load */
    getPreviousValues = () => {
        const previous = getMaintainData(previousState);
        const allow = !notAllow.includes(this.props.history.location.pathname);
        const check = this.props.history.action === "POP" && this.props.previousPath.component === "itemview" && allow;
        if (previous && previous.apply && check) {
            const temp = getMaintainData(estateSaleCategory);
            if (temp) {
                this.setState({
                    ...this.state,
                    ...temp,
                    pageLoading: false,
                    scrollToPrevious: true
                }, () => {
                    this.scrolledAt = temp.scrollTo;
                    this.getFavoriteLocationDetails();
                });
            } else {
                this.getRequiredData();
            }
        } else {
            this.getRequiredData();
        }
    }

    scrollToPrevious = () => {
        this.scrollRef.current.scrollTo({ top: this.scrolledAt, left: 0 });
    }

    /* Getting sale details, sale image list and location details */
    getRequiredData = () => {
        this.getSaleImagesList();
        this.getCounts();

        const saleDetailData = { "sort": [{ "field": "title", "direction": "asc" }] };

        SalesService.getSaleDetails(this.state.saleId, saleDetailData).then(
            saleDetail => {

                const saleDetailsData = saleDetail.data.data[0];
                this.getLocationImagesList(saleDetailsData.locationid);
                CategoryService.getCategorySelectionList().then(categorySelectionList => {
                    const tempCategoryList = categorySelectionList.data.data.data;
                    this.setState({
                        saleDetails: saleDetailsData,
                        categoryCount: {
                            ...this.state.categoryCount,
                            menu: tempCategoryList
                        },
                        saleTitle: saleDetailsData.title,
                        pageLoading: false
                    }, () => {
                        this.getFavoriteLocationDetails();
                        this.handleScroll();
                    });
                }
                ).catch((error) => {
                    // TODO: Error message handle
                    this.setState({
                        noRecordFound: true,
                        pageLoading: false
                    });
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                noRecordFound: true,
                pageLoading: false
            })
        });
    }

    getSaleImagesList = () => {
        const imageListData = { "filter": [{ "field": "saleid", "value": this.state.saleId, "op": "=", "join": "AND" }] };
        SalesService.getSaleImagesList(imageListData).then(
            imagesList => {
                this.setState({
                    saleImageList: imagesList.data.data,
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
        });

    }

    getLocationImagesList = (locationId) => {
        const locationImageData = { "filter": [{ "field": "locationid", "value": locationId, "op": "=", "join": "AND" }] };
        // const locationDetailData = {
        //     "filter": [{ "field": "id", "value": locationId, "op": "=", "join": "AND" }],
        //     "sort": [{ "field": "title", "direction": "asc" }]
        // };

        /* Getting location details */
        LocationService.getLocationDetails(locationId, { data: {} }).then(
            location => {
                this.setState({
                    locationDetails: location.data.data[0],
                }, () => {

                    // google analytics config for item list page
                    window.gtag('config', gaID, {
                        'page_title': 'Item-List',
                        'page_path': this.props.location.pathname
                    });
                    if (location.data.data[0]['googlecode']) {
                        window.gtag('config', location.data.data[0]['googlecode'], {
                            'page_title': 'Item-List',
                            'page_path': this.props.location.pathname
                        });
                    }
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
        LocationService.getLocationImagesList(locationImageData).then(
            locationImage => {
                this.setState({
                    locationImageList: locationImage.data.data,
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
    }

    getCounts = () => {
        const count = { "data": { "saleid": this.state.saleId } };
        CategoryService.getCategoryCount(count).then(
            categoryCount => {
                const tempCount = categoryCount.data.data;
                CategoryService.getAreaCount(count).then(
                    areaCount => {
                        this.setState({
                            categoryCount: {
                                ...this.state.categoryCount,
                                orginal: tempCount
                            },
                            areaCount: areaCount.data.data,
                        })
                    }
                ).catch((error) => {
                    // TODO: Error message handle
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
        })
    }

    getTopLayout = () => {
        /* Getting required elements */
        const covidBannerCheck = document.getElementsByClassName('covid-banner');
        const covidBanner = covidBannerCheck.length > 0 ? covidBannerCheck[0].getBoundingClientRect().height : 0;
        const topLayout = document.getElementsByClassName('top-layout')[0] ? document.getElementsByClassName('top-layout')[0].getBoundingClientRect().height : 0;
        const mobileBanner = document.getElementById('mobile-banner') ? document.getElementById('mobile-banner').getBoundingClientRect().height : 0;
        this.setState({
            sideBarScrollHeight: covidBanner + topLayout + mobileBanner
        });
    }

    /* Called when resize the screen */
    windowWidthGet = () => {
        this.getTopLayout();
        this.setState({
            innerWidth: window.innerWidth,
            pageClientWidth: this.scrollRef?.current?.clientWidth,
        }, () => {
            if (this.state.innerWidth < 992) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
            } else if (this.state.innerWidth > 992) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
            }
        });
    }

    isDisabledLink = (flag) => {
        const list = ['Collectibles', 'Craft & Hobby', 'Electronics', 'Jewlery', 'Motor Vechicles']
        return list.includes(flag);
    }

    /* Called when scroll content */
    handleScroll = (event = null) => {
        try {
            let scrollTop = event?.target?.scrollTop || 0;
            
            if (this.props.handleScroll) {
                this.props.handleScroll(scrollTop);
            }

            this.handleVisible(event);
            
            /* Storing scroll-top for handle previous state */
            this.scrolledAt = scrollTop;
        }
        catch (e) {

        }
    };

    handleVisible = (event) => {
        this.setState({
            pageClientWidth: this.scrollRef?.current?.clientWidth,
            isVisible: event?.target?.scrollHeight ? (event.target.scrollHeight / 4) < event.target.scrollTop : false,
        });
    }

    openInNewTab = (url) => {
        if (url) {
            const reformat = url.includes('http') ? url : 'http://' + url;
            const newWindow = window.open(reformat, '_blank', 'noopener,noreferrer');
            if (newWindow) newWindow.opener = null;
            let dataLayerData = {
                'event': 'location_visit',
                'title': this.state.locationDetails.title
            }
            addDataLayer(dataLayerData);
        }
    }

    areaDropDownSelect = ($event) => {
        if ($event !== "-1") {
            const flag = this.state.area[$event].count;
            this.selectArea(flag, $event);
        } else {
            this.selectArea("ALL", "-1");
        }
    }

    getSaleBannerImage = () => {
        // const saleImage = this.state.saleImageList.length > 0 ? this.state.saleImageList[0] : {};
        // const check = saleImage.saleimageurl ? saleImage.saleimageurl.split(',') : saleImage.locationimageurl ? saleImage.locationimageurl.split(',') : [];
        const check = [];
        const banner = check.length > 0 ? check[0].split('banner#*#') : [];
        const image = banner.length > 0 ? banner[1] : null;
        return image ? image : this.state.banner_images.bgImage;
    }
    fontColorCheck = () => {
        const bgImage = this.getSaleBannerImage();
        let fontColor = "#ffff";
        if (bgImage === "/static/images/EstateSale/Banner/Banner_steel.jpg" || bgImage === "/static/images/EstateSale/Banner/Banner_neon.jpg" ) {
            fontColor =  '#000000'; 
        }
        return fontColor

    }

    hideHomeIcon = () => {
        // const saleImage = this.state.saleImageList.length > 0 ? this.state.saleImageList[0] : {};
        // const check = saleImage.saleimageurl ? saleImage.saleimageurl.split(',') : saleImage.locationimageurl ? saleImage.locationimageurl.split(',') : [];
        const check = [];
        const banner = check.length > 0 ? check[0].split('banner#*#') : [];
        const image = banner.length > 0 ? banner[1] : null;
        return !image;
    }

    selectMenu = (flag) => {
        this.closeSideBar();
        if (flag) {
            this.setState({
                activeMenuStatus: true,
                activeMenuValue: flag
            });
        }
        // const check = this.state.activeMenu === flag;
        const value = flag;
        this.setState({
            activeMenu: value
        }, () => {
            this.selectCategory(value, false, true);
        });
    }

    selectCategory = (flag, makeNull = false, fromMenu) => {
        this.closeSideBar();
        if (flag) {
            this.setState({
                activeSubMenuValue: flag,
                activeSubMenuStatus: true
            })
        }
        if (!fromMenu) {
            this.setState({
                activeMenuStatus: false
            })
        }
        if (flag === "ALL") {
            this.setState({
                activeSubMenuValue: '',
                activeSubMenuStatus: false,
                activeMenuStatus: false
            });
        }
        const check = this.state.activeMenu;
        let areaFilter = this.state.items.filter;
        const areaIndex = areaFilter.findIndex(x => x.field === "area");
        if (areaIndex !== -1) {
            areaFilter.splice(areaIndex, 1);
        }
        this.setState({
            showItems: false,
            activeMenu: makeNull ? '' : check,
            activeAreaIndex: "-1",
            filter: areaFilter,
            itemCount: 0
        }, () => {
            const categoryFilter = [{ "field": fromMenu ? 'categoryGroup' : "category", "value": flag, "op": "=", "join": "AND" }];
            if (!fromMenu && this.state.activeMenu) {
                categoryFilter.push({ "field": 'categoryGroup', "value": this.state.activeMenu, "op": "=", "join": "AND" })
            }
            let filter = this.state.items.filter;
            const index = filter.findIndex(x => x.field === "category");
            const categoryGroupIndex = filter.findIndex(x => x.field === "categoryGroup");
            if (categoryGroupIndex !== -1) {
                filter.splice(categoryGroupIndex, 1);
            }
            if (index !== -1) {
                filter.splice(index, 1);
            }
            if (flag !== 'ALL') {
                filter = filter.concat(categoryFilter);
            }
            this.setState({
                activeCategory: flag,
                items: {
                    ...this.state.items,
                    filter: filter
                },
                showItems: true
            });
        });
        let dataLayerData = {
            'event': 'category',
            'title': flag
        }
        addDataLayer(dataLayerData);   
    }

    selectCategoryDropDown = (event) => {
        this.selectCategory(event.target.value);
    }

    sortByChange = (event) => {
        this.setState({
            showItems: false,
            sortActive: event,
            itemCount: 0
        }, () => {
            const filterValue = {
                "1": { field: "itemclosetime", value: "asc" },
                "2": { field: "title", value: "asc" },
                "3": { field: "title", value: "desc" },
                "4": { field: "id", value: "desc" },
                "5": { field: "id", value: "asc" },
                "6": { field: "bidprice", value: "desc" },
                "7": { field: "bidprice", value: "asc" },
                "8": { field: "SKU", value: "asc" },
            };

            const value = filterValue[event];
            const final = [{ "field": value.field, "direction": value.value }];
            this.setState({
                items: {
                    ...this.state.items,
                    sort: final,
                },
                showItems: true
            });
        });
    }

    onChangeCheckbox = (event, value) => {
        this.setState({
            showItems: false,
            itemCount: 0,
            isshippable : event === "isshippable" ? !value : this.state.isshippable,
            ispickuponly : event === "ispickuponly" ? !value : this.state.ispickuponly
        }, () => {
            let itemData = {...this.state.items}
            let index = itemData.filter.findIndex(elem => elem.field == "isshippable")
            let value = []
            if(this.state.isshippable){
                value.push(1);
            }
            if(this.state.ispickuponly){
                value.push(0);
            }
            if(index > -1){
                if(value.length > 0){
                    itemData.filter[index]['value'] = [value];
                } else {
                    itemData.filter.splice(index,1);
                }  
            }else {
                itemData.filter.push({field: "isshippable", value: [value], op: "IN", join: "AND"})
            }
            this.setState({
                items: itemData,
                showItems: true
            });
        }   
    )}

    selectArea = (flag, activeAreaIndex) => {
        let categoryFilter = this.state.items.filter;
        const categoryIndex = categoryFilter.findIndex(x => x.field === "category");
        if (categoryIndex !== -1) {
            categoryFilter.splice(categoryIndex, 1);
        };
        const categoryGroupIndex = categoryFilter.findIndex(x => x.field === "categoryGroup");
        if (categoryGroupIndex !== -1) {
            categoryFilter.splice(categoryGroupIndex, 1);
        }
        this.setState({
            showItems: false,
            activeMenu: 'ALL',
            activeCategory: 'ALL',
            filter: categoryFilter,
            activeMenuValue: '',
            activeMenuStatus: false,
            itemCount: 0
        }, () => {
            const categoryFilter = [{ "field": "area", "value": flag, "op": "=", "join": "AND" }];
            let filter = this.state.items.filter;
            const index = filter.findIndex(x => x.field === "area");
            if (index !== -1) {
                filter.splice(index, 1);
            }
            if (flag !== 'ALL') {
                filter = filter.concat(categoryFilter);
            }
            this.setState({
                items: {
                    ...this.state.items,
                    filter: filter
                },
                showItems: true,
                activeAreaIndex: activeAreaIndex
            });
        });
    }

    getCountForCategory = (menuName) => {
        let count = 0;
        const category = this.state.categoryCount.orginal.filter(x => x.groupCategory === menuName);
        category.forEach(x => { count += x.count });
        return count;
    }

    getCountForSubCategory = (flag, menuName) => {
        const category = this.state.categoryCount.orginal.filter(x => x.category === flag && x.groupCategory === menuName);
        const count = category.length > 0 ? category[0].count : 0;
        return count;
    }

    sideNavbarTag = (menu, i, menuName) => {
        return (
            menu?.length > 1 ? <li>
                <div className={`d-flex flex-column ${this.state.activeMenu === menuName ? 'active-item' : ''}`}>
                    <div className="clickable" onClick={() => this.selectMenu(menuName)}>
                        <div className={`d-flex flex-row menu-item ${this.state.activeMenuStatus && this.state.activeMenuValue === menuName ? 'menu-item-active' : ''} ${1 === 0 ? 'disabled' : ''}`}>
                            <div className="d-flex flex-row align-items-center justify-content-between menu-item-name">
                                <div className="d-flex"><span className="expand-handle"></span>&ensp;<div>{menuName}&ensp;&#40;{this.getCountForCategory(menuName)}&#41;
                                </div></div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-center justify-content-center sub-menu">
                        {
                            React.Children.toArray(menu.map((sub_menu, j) => {
                                return (
                                    <div className={`sub-menu-item clickable ${this.state.activeSubMenuStatus && this.state.activeSubMenuValue === sub_menu.subcategory ? 'sub-menu-active' : ''}`} onClick={() => this.selectCategory(sub_menu.subcategory)} key={`sub_links${j}`}>
                                        <div className={`d-flex flex-row`}>
                                            <div className="d-flex flex-column align-items-start justify-content-end sub-menu-item-name">
                                                <div className="d-flex"><span></span>&ensp;<div>{sub_menu.subcategory}&ensp;&#40;{this.getCountForSubCategory(sub_menu.subcategory, menuName)}&#41;
                                                </div></div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>
            </li> : <li onClick={() => this.selectMenu(menuName)}>
                <div className={`d-flex flex-column ${menu?.count === 0 ? 'disabled' : ''} ${this.state.activeCategory === menuName ? 'menu-item-active' : ''}`}>
                    <div>
                        <div className="d-flex flex-row menu-item">
                            <div className="d-flex flex-column align-items-start justify-content-center menu-item-name">
                                <div className="d-flex"><span></span>&ensp;<div>{menuName}&ensp;&#40;{this.getCountForCategory(menuName)}&#41;
                                </div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    }

    /* Called when click window */
    handleClickOutside = (e) => {
        if (this.sideNavbar && this.sideNavbar.contains(e.target)) {
            // the click happened in the component
            return;
        }

        // click happened outside the component
        // hide the sidebar
        const class_list = e.target.classList ? [...e.target.classList] : [];
        if (!class_list.includes('fa-bars') && !class_list.includes('category-field')) {
            if (this.props.customSidebar.icon) {
                store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
            }
        }
    }

    getAreaCount = (flag) => {
        const area = this.state.areaCount.filter(x => x.area === flag);
        return area.length > 0 ? area[0].count : 0;
    }

    getItemsList = (event) => {
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "EstateSaleByCategory", state: { prevPath: this.props.location.pathname } } });
        if (this.state.scrollToPrevious && event.scrollPage) {
            this.scrollToPrevious();
        }
        this.setState({ itemCount: event.length });
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    stateMaintenance = () => {
        const data = {
            locationDetails: this.state.locationDetails,
            saleImageList: this.state.saleImageList,
            saleDetails: this.state.saleDetails,
            locationImageList: this.state.locationImageList,
            categoryCount: this.state.categoryCount,
            areaCount: this.state.areaCount,
            scrollTo: this.scrolledAt,
            showCaringInHeader: this.state.showCaringInHeader,
            activeAreaIndex: this.state.activeAreaIndex,
            activeCategory: this.state.activeCategory,
            activeMenu: this.state.activeMenu,
            items: this.state.items,
            sortActive: this.state.sortActive,
            activeMenuStatus: this.state.activeMenuStatus,
            activeMenuValue: this.state.activeMenuValue,
            activeSubMenuStatus: this.state.activeSubMenuStatus,
            activeSubMenuValue: this.state.activeSubMenuValue,
            isshippable: this.state.isshippable,
            ispickuponly: this.state.ispickuponly
        };
        convertToMaintainData(estateSaleCategory, data);
    }

    componentWillUnmount() {
         window.removeEventListener('resize', this.handleResize);
        store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: false, open: false } });
        store.dispatch({ type: 'SHOW_ESTATE_DETAIL', payload: { show: false, extraData: null } });
        window.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener('resize', this.windowWidthGet);
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    mobileViewSideBar = () =>
    (<div className={`sidenav ${this.state.innerWidth < 992 ? 'mobile-sidenav' : ''} ${this.props.customSidebar.icon ? this.props.customSidebar.open ? '' : 'd-none' : 'd-none'}`}
        ref={node => this.sideNavbar = node} style={this.state.innerWidth < 992 ? { paddingBottom: `${this.state.sideBarScrollHeight}px` } : {}}>
        <div className="sticky-sidebar">
            {/* <div className="d-flex d-lg-none flex-row align-items-center justify-content-between sidebar-tools">
        <div className="d-flex flex-row">
            <div className="d-flex flex-row profile-border-outer">
                <div className="profile-border-inner">
                    <img src={this.props['user']['profileImage'] ? this.props['user']['profileImage'] : (process.env.PUBLIC_URL + '/static/icons/profile/default_1.svg')} alt="profile" height="28" width="26" className="profile" />
                </div>
            </div>
            <div className="d-flex flex-row align-items-center">
                <b>{`${this.props['user']['lastName']},${this.props['user']['firstName']}`}</b>
            </div>
        </div>
    </div> */}
            <div className="h5 top-text">Search By Categories</div>
            <div className={`all-link clickable ${this.state.activeCategory === "ALL" ? 'menu-item-active' : ''}`} onClick={() => this.selectCategory('ALL')}>All <span> {this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0}</span></div>
            <div className="nav-links-handle">
                <ul className="d-flex flex-column menu-list">
                    {
                        React.Children.toArray(
                            this.state.categoryCount.menu.map((menu, i) =>
                                this.sideNavbarTag(menu.selection, i, menu.category))
                        )}
                </ul>
            </div>
        </div>
    </div>);

    moreEstateLocations = () => {
        const location = this.state?.locationDetails;
        if (location.id) {
            const LocationUrl = location.locationcode ? `/estate-sales/${location.locationstatecode}/${location.locationcode}` : `/estate-sales/${location.locationstatecode}`;
            this.props.history.push(LocationUrl);
        }
    }

    header = () =>
    (<div className="header-content" ref={this.headerContentRef} style={{ backgroundImage: `url(${this.getSaleBannerImage()})` }}>
        <div className="d-md-flex justify-content-between">
            <div className="left d-flex flex-column justify-content-start">
                <div>
                    <h3  style={{color: `${this.fontColorCheck()}`}}>{this.state.saleDetails.title}</h3>
                    {/* {this.state.saleDetails.address1}, {this.state.saleDetails.city} {this.state.saleDetails.zipcode} */}
                </div>
                <div className="">
                    <div  style={{color: `${this.fontColorCheck()}`}}>{this.state.saleDetails.provenance}</div>
                </div>
                <div className="sale-provinance">
                    {/* Sale Provinance */}
                </div>
            </div>
            <div className="right d-flex justify-content-end align-items-center">
                <div className={`icon-image ${this.hideHomeIcon() ? '' : 'd-none'}`}>
                    <img src={this.state.banner_images.iconImage} alt="icon" style={{ width: `${this.state.innerWidth > 1366 ? '70%' : '100%'}` }}></img>
                </div>
                <div className="caring-transition">
                    <div className="header">
                        Caring Transitions Location
                    </div>
                    <div className="body-content">
                        <div className="user-details d-flex align-items-center clickable" onClick={() => this.openInNewTab(this.state.locationDetails.website)}>
                            {
                                React.Children.toArray(this.state.locationImageList.filter(x => x.name === 'profile').map((x, index) =>
                                    <img src={x.url} className="phone-icon" alt="phone-icons"></img>
                                ))
                            }
                            {
                                this.state.locationImageList.filter(x => x.name === 'profile').length === 0 ? <img src={image_thumbnail} className="phone-icon" alt="phone-icons" key={`location_image_0`}></img> : null
                            }
                            <div className="name clickable">
                                <div>{this.state.locationDetails.contactname}</div>
                                <div >
                                    <div className="light-color city-alignment city-new-site-alignment">{titleCase(this.state.locationDetails.city)}</div>
                                    <div className="website city-website-alignment city-new-site-alignment">
                                        <i className="fas fa-globe"></i> <span>Visit Site</span>
                                    </div>
                                </div>
                                { this.state.locationDetails.auctioneerlicense ? <div className='text-secondary license-resp' style={{  wordBreak: "break-all", overflowWrap: "break-word", maxWidth: "350px" }}><b>License:</b> {this.state.locationDetails.auctioneerlicense}</div> : '' }
                            </div>
                        </div>
                        <div className="email">
                            <i className="fas fa-envelope"></i>  <a href={`mailto:${this.state.locationDetails.email}`}>{this.state.locationDetails.email}</a>
                        </div>
                        <div className="phone">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/common-icons/phone.svg`} className="phone-icon" alt="phone-icons"></img><a href={`tel:${this.state.locationDetails.phone}`}>{this.state.locationDetails.phone}</a>
                        </div>
                        <div className="more-sale" onClick={this.moreEstateLocations}>
                            <i className="fas fa-link"></i> <span className="clickable click-more-sale">Please click to check for more sales</span>
                        </div>
                        {
                            isAuthorized() && this.state.favoriteDetailsLoaded ?
                                <div className="favorite-icon d-flex align-items-center">
                                    <Form.Check onChange={(event) => { this.favoriteLocation(event) }}
                                        checked={this.isFavoriteLocation()}
                                        type="checkbox"
                                        id={`customControlAutosizing`}
                                        label="Favorite Location"
                                        className='favorite-checkbox'
                                        disabled={this.state.locationInProgress}
                                        custom
                                    />
                                    {
                                        this.state.locationInProgress ?
                                            <Spinner animation="border" variant="danger" /> : null
                                    }
                                </div> : null
                        }

                    </div>
                </div>
            </div>
        </div>
    </div>);


    sideBar = () =>
    (this.state.innerWidth > 992 ?
        <div className={`sidenav`} ref={this.sideNavbarRef}>
            <div className={`sticky-sidebar`} >
                <div className="h5 top-text">Search By Categories</div>
                <div className={`all-link clickable ${this.state.activeCategory === "ALL" ? 'menu-item-active' : ''}`} onClick={() => this.selectCategory('ALL', true)}>All <span>{this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0}</span></div>
                <div className="nav-links-handle">
                    <ul className="d-flex flex-column menu-list">
                        {
                            React.Children.toArray(this.state.categoryCount.menu.map((menu, i) => this.sideNavbarTag(menu.selection, i, menu.category))
                            )}
                    </ul>
                </div>
            </div>
        </div>
        : null);

    categorySection = () => (
        <>
            <div className="instruction h4 text-center">
                Search by Room Location to View and Bid on Unique and Everyday Treasures
            </div>
            {
                this.state.innerWidth > 992 ?
                    <div className="d-md-flex category-list">
                        <div className={`area-image-container ${this.getAreaCount('Living Room') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Living Room', 0)}>
                            <img src={LivingRoom} alt="living-room"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Living Room</div>
                                    <div className="count">{this.getAreaCount('Living Room')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Kitchen & Dining') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Kitchen & Dining', 1)}>
                            <img src={KitchenDinning} alt="Kitchen and Dining Room"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Kitchen &amp; Dining</div>
                                    <div className="count">{this.getAreaCount('Kitchen & Dining')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Office') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Office', 2)}>
                            <img src={Office} alt="Office"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Office</div>
                                    <div className="count">{this.getAreaCount('Office')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Bedroom') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Bedroom', 3)}>
                            <img src={Bedroom} alt="Bedroom"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Bedroom</div>
                                    <div className="count">{this.getAreaCount('Bedroom')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Kids Playroom') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Kids Playroom', 4)}>
                            <img src={KidsPlayroom} alt="Kids Playroom"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Kids Playroom</div>
                                    <div className="count">{this.getAreaCount('Kids Playroom')}</div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            {
                this.state.innerWidth > 992 ?
                    <div className="d-md-flex category-list">
                        <div className={`area-image-container ${this.getAreaCount('Garage') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Garage', 5)}>
                            <img src={Garage} alt="Garage"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Garage</div>
                                    <div className="count">{this.getAreaCount('Garage')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Entertainment Cave') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Entertainment Cave', 6)}>
                            <img src={Entertainment_cave} alt="Entertainment Cave"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Entertainment Cave</div>
                                    <div className="count">{this.getAreaCount('Entertainment Cave')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Laundry Storage') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Laundry Storage', 7)}>
                            <img src={LaundryStorage} alt="Laundry Storage"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Laundry Storage</div>
                                    <div className="count">{this.getAreaCount('Laundry Storage')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Patio & Lawn') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Patio & Lawn', 8)}>
                            <img src={PatioLawn} alt="Lawn"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Patio &amp; Lawn</div>
                                    <div className="count">{this.getAreaCount('Patio & Lawn')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={`area-image-container ${this.getAreaCount('Barn') > 0 ? '' : 'zero'}`}
                            onClick={() => this.selectArea('Barn', 9)}>
                            <img src={Barn} alt="Barn"></img>
                            <div className={`image-title`}>
                                <div className="d-flex justify-content-between">
                                    <div className="category-name">Barn</div>
                                    <div className="count">{this.getAreaCount('Barn')}</div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
            {
                this.state.innerWidth > 992 && this.state.activeAreaIndex !== "-1" ?
                    <div className="selected-area d-flex">
                        <div className="d-flex align-items-center area">
                            <div className="text">
                                {this.state.area[this.state.activeAreaIndex]?.name}<span className="dropdown-count">
                                    ({this.getAreaCount(this.state.area[this.state.activeAreaIndex]?.count)})
                                </span>
                            </div>
                            <div className="close clickable" onClick={() => this.selectArea('ALL', "-1")}>&times;</div>
                        </div>
                    </div> : null
            }
        </>);

    filterSection = () => (
        <div className={`filter-section d-lg-flex align-items-center justify-content-between mb-3`}>
            <div className="d-lg-flex align-items-center">
                {/* <div className="search-box">
                <div className="input-group">
                    <input className="form-control py-2" id="catrgory-search-input" placeholder="Search on this sale"></input>
                    <span className="input-group-append align-items-center clickable">
                        <i className="fa fa-search"></i>
                    </span>
                </div>
            </div> */}
                {/* <div className="items-select d-flex align-items-center">
                <div className="title">Items</div>
                <Form.Group controlId="Items.ControlSelect">
                    <Form.Control as="select">
                        <option>All</option>
                        <option>Antique others</option>
                        <option>Furniture</option>
                    </Form.Control>
                </Form.Group>
                    </div> */}
                <div className="sort-by d-flex align-items-center">
                    <div className="title">Sort by</div>
                    {/* <Form.Control as="select" onChange={this.sortByChange} value={this.state.sortActive}>
                        <option value="5">Ending First</option>
                        <option value="3">Item Name A-Z</option>
                        <option value="4">Item Name Z-A</option>
                        <option value="1">Newest - Oldest</option>
                        <option value="2">Oldest - Newest</option>
                        <option value="6">Price High - Low</option>
                        <option value="7">Price Low - High</option>
                        <option value="8">SKU #</option>
                    </Form.Control> */}
                    <Dropdown onSelect={this.sortByChange}>
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                            <div>
                                {this.sortByMenu[this.state.sortActive]}
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="custom-dropdown-menu">
                            {
                                React.Children.toArray(Object.keys(this.sortByMenu).map(sotyByKey =>
                                    <Dropdown.Item eventKey={sotyByKey}
                                        active={this.state.sortActive === sotyByKey}>
                                        {this.sortByMenu[sotyByKey]}
                                    </Dropdown.Item>))
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="checkbox-ml-10">
                    <div className="d-md-flex">
                        <Form.Group className="multiple-checkbox checkbox-bottom">
                            <Form.Check custom type="checkbox" id="isshippable" name="isshippable" label="Shippable" onClick={() => this.onChangeCheckbox('isshippable', this.state.isshippable)}/>
                        </Form.Group>
                    </div>
                </div>
                <div className="checkbox-ml-10">
                    <div className="d-md-flex">
                        <Form.Group className="multiple-checkbox checkbox-bottom">
                            <Form.Check custom type="checkbox" id="pickuponly" name="ispickuponly" label="Pick Up Only" onClick={() => this.onChangeCheckbox('ispickuponly', this.state.ispickuponly)}/>
                        </Form.Group>
                    </div>
                </div>
                {
                    this.state.innerWidth < 992 ?
                        <div className="sort-by d-flex align-items-center category-field" onClick={this.openSideBar}>
                            <div className="title category-field">Categories</div>
                            {/* <Form.Control as="select" id="category" name="category" value={this.state.activeCategory} className={this.state.activeCategory ? 'form-control-active' : ''} placeholder=" " required onChange={(event) => this.selectCategoryDropDown(event)}>
                                <option value="ALL">All({this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0})</option>
                                {
                                    React.Children.toArray(this.state.categoryCount.menu.map((category, index) =>
                                        <optgroup label={category.category + `(${this.getCountForCategory(category.selection)})`} style={{ backgroundColor: "#efefef" }}>
                                            {
                                                category.selection.length > 0 ?
                                                    React.Children.toArray(category.selection.map((subcategory, subIndex) =>
                                                        <option value={subcategory.subcategory} style={{ backgroundColor: "white" }}>
                                                            {subcategory.subcategory + `(${this.getCountForSubCategory(subcategory.subcategory)})`}
                                                        </option>
                                                    )) :
                                                    <option key={index + 'no' + index} disabled style={{ backgroundColor: "white" }}>- - - - -</option>
                                            }
                                        </optgroup>
                                    ))
                                }
                            </Form.Control> */}
                            <Form.Control value={this.getCategoryValue()} className={`category-field category-field-input ${this.state.activeCategory ? 'form-control-active' : ''}`} placeholder=" "
                                readOnly />
                        </div> : null
                }
            </div>
            <div className="d-lg-flex align-items-center">
                {
                    this.state.innerWidth < 992 ?
                        <div className="sort-by d-flex align-items-center">
                            <div className="title">Area</div>
                            <Dropdown onSelect={this.areaDropDownSelect}>
                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                    {
                                        this.state.activeAreaIndex === "-1" ? <div>All ({this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0})</div> :
                                            <div>
                                                {this.state.area[this.state.activeAreaIndex]?.name} <span className="dropdown-count">
                                                    ({this.getAreaCount(this.state.area[this.state.activeAreaIndex]?.count)})
                                                </span>
                                            </div>
                                    }
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="custom-dropdown-menu">
                                    <Dropdown.Item eventKey="-1" active={this.state.activeAreaIndex === "-1"}>
                                        All ({this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0})
                                    </Dropdown.Item>
                                    {
                                        React.Children.toArray(this.state.area.map((area, index) =>
                                            <Dropdown.Item eventKey={index}
                                                active={this.state.activeAreaIndex === index.toString()} disabled={this.getAreaCount(area.count) === 0}>
                                                {area.name} <span className="dropdown-count"> ({this.getAreaCount(area.count)})</span>
                                            </Dropdown.Item>))
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div> : null
                }
            </div>
        </div>);

    listSection = () => (<div style={{height: this.state.itemCount == 0 ? '50%' : 'unset'}}>
        {
            this.state.showItems ? <SaleCardViewDataTable
                // useVirtualized
                locationDetails={this.state.locationDetails}
                categoryCount={this.state.categoryCount}
                config={{ postData: this.state.items }}
                {...this.props}
                getItemsList={this.getItemsList}
                addClosingOrder
                showMoreButton
                addEstateBidPrice
                stateMaintenance={this.stateMaintenance} 
                categoryName={this.state.activeMenu}
                showAd
            ></SaleCardViewDataTable> : null
        }
    </div>);

    openSideBar = (event) => {
        if (window.innerWidth < 992) {
            this.getTopLayout();
            store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: !this.props.customSidebar.open } });
        }
    }

    closeSideBar = () => {
        if (window.innerWidth < 992) {
            store.dispatch({ type: 'SET_CUSTOM_SIDEBAR', payload: { icon: true, open: false } });
        }
    }

    getCategoryValue = () => {
        const value = this.state.activeCategory;
        if (value === 'ALL') {
            return value + ' (' + (this.state.categoryCount.orginal[0]?.count ? this.state.categoryCount.orginal[0]?.count : 0) + ')';
        }
        if (this.state.activeMenuStatus) {
            const getCategory = this.state.categoryCount.menu.filter(x => x.category === value);
            const selection = getCategory[0]?.category;
            if (selection) {
                const count = this.getCountForCategory(selection)
                return value + ' (' + count + ')';
            }
            return value;

        } else {
            const subCount = this.getCountForSubCategory(value, this.state.activeMenu);
            return value + ' (' + subCount + ')';
        }
    }

    getFavoriteLocationDetails = () => {
        const postData = {
            "sort": [{ "field": "id", "direction": "asc" }],
            "field": ["id", "locationid", "buyerid"],
            "page": { "size": 999 }
        };
        if (isAuthorized()) {
        LocationService.getFavoriteLocation(postData).then(res => {
            const data = res.data.data;
            this.setState({
                favoriteLocations: data,
                favoriteDetailsLoaded: true
            });
        }).catch(error => {
            this.setState({
                favoriteLocations: [],
                favoriteDetailsLoaded: false
            })
        });
        }
    }

    favoriteLocation = (event) => {
        event.stopPropagation();
        event.preventDefault();
        const locationId = this.state.saleDetails.locationid;
        const value = event.target.checked;
        this.setState({
            locationInProgress: true
        }, () => {
            if (value) {
                this.addFavoriteLocation(locationId);
            } else {
                this.removeFavoriteLocation(locationId);
            }
        });
    }

    addFavoriteLocation = (location) => {
        const postData = { "data": { "locationid": location } };
        LocationService.addFavoriteLocation(postData).then(res => {
            const favoriteLocations = this.state.favoriteLocations;
            const data = res.data.data[0];
            data['buyerid'] = this.props.user.id;
            favoriteLocations.push(data);
            this.setState({
                favoriteLocations,
                locationInProgress: false
            });
        }).catch(error => {
            this.setState({
                locationInProgress: false
            });
        });
    }

    removeFavoriteLocation = (location) => {
        const favoriteLocations = this.state.favoriteLocations;
        const locationData = favoriteLocations.findIndex(x => x.locationid === location);
        const postData = { "data": { "locationIds": [{ "id": location }] } };
        LocationService.deleteFavoriteLocation(postData).then(res => {
            favoriteLocations.splice(locationData, 1);
            this.setState({
                favoriteLocations,
                locationInProgress: false
            });
        }).catch(error => {
            this.setState({
                locationInProgress: false
            });
        });
    }

    isFavoriteLocation = () => {
        const locationId = this.state.saleDetails.locationid;
        return this.state.favoriteLocations.findIndex(x => x.locationid === locationId) > -1;
    }

    render() {
        return (
            <div className="estate-sale-category" onScroll={event => this.handleScroll(event)} ref={this.scrollRef}
                style={{ ...this.props.style }}>
                    <Helmet>
                        <title>{this.state.saleTitle}</title>
                        <meta name='description' content={this.state.saleDetails.provenance} />
                        <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    </Helmet>      
                {
                    this.state.isVisible ?
                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                            <i className="fas fa-arrow-up"></i>
                        </div> : null
                }
                {
                    this.state.pageLoading ?
                        <div className="loader d-flex align-items-center justify-content-center">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        this.state.noRecordFound ?
                            <div className="no-data-found mt-3 h-100 d-flex flex-column align-items-center justify-content-center">
                                <div className="text-center no-data-search-icon">
                                    <i className="fas fa-search fa-3x"></i>
                                </div>
                                <div className="text-center h4 text-bold">
                                    No results found
                                </div>
                                <div className="text-center text-muted h5">
                                    We couldn't find what you're looking for.
                                </div>
                            </div> :
                            <div className="h-100">
                                {this.mobileViewSideBar()}
                                {this.header()}
                                <div className="d-flex sale-list-container">
                                    {this.sideBar()}
                                    <div className="content-container">
                                        {this.categorySection()}
                                        {this.filterSection()}
                                        {this.listSection()}
                                    </div>
                                </div>
                            </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(EstateSaleByCategory);